module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_6005.76af7b14.png";